<template>
  <div>
    <div class="cancel-button" v-if="showCancel">
      <a href="#" @click.prevent="open">
        <img src="images/x.svg" />
      </a>
    </div>

    <modal name="cancel-modal" :width="900" :height="600" @opened="cancelModalOpened" @closed="cancelModalClosed">
      <div id="cancel-dialog">
        <h1 class="mt-10">{{ getDialogText() }}</h1>
        <button
          class="py-5 px-40 rounded-full mt-10"
          style="color: white !important; background-color: #544B45"
          @click="close"
        >{{ getCancelText() }}</button>
        <button
          class="bg-white py-5 px-40 rounded-full mt-5"
          style="border: 3px solid #544B45"
          @click="restart"
        >{{ getOkText() }}</button>
      </div>
    </modal>
    <router-view />
  </div>
</template>

<style>
@font-face {
  font-family: VerlagBlack;
  src: url("/fonts/Verlag-Black.otf") format("opentype");
}

@font-face {
  font-family: FoundryWilsonNormal;
  src: url("/fonts/FOWILSN2.otf") format("opentype");
}

@font-face {
  font-family: FoundryWilsonMedium;
  src: url("/fonts/FOWILSM2.otf") format("opentype");
}

@font-face {
  font-family: FoundryWilsonBlack;
  src: url("/fonts/FOWILSB2.otf") format("opentype");
}

@font-face {
  font-family: FoundryWilsonItalic;
  src: url("/fonts/FOWILSI2.otf") format("opentype");
}

body {
  margin: 0;
  color: #ffffff;
  background-color: #00692f;
  font-family: VerlagBlack;
  font-size: 27px;
  letter-spacing: 4px;
}

p {
  margin-bottom: 15px;
}

button {
  font-size: 27px !important;
  color: #544b45 !important;
  text-transform: uppercase !important;
  letter-spacing: 4px !important;
}

.cancel-button {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 72px;
  height: 72px;
}

#cancel-dialog {
  text-align: center;
  padding: 40px;
  width: 900px;
  height: 600px;
  background: white;
}

#cancel-dialog h1 {
  text-transform: uppercase;
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  line-height: 100%;
  color: #544b45;
}

#cancel-dialog button {
  text-transform: uppercase;
  width: 760px;
}

.spinner {
  display: inline-block;
  width: 30px !important;
  height: 30px !important;
}

.spinner > div {
  background: white !important;
  width: 40px !important;
  height: 40px !important;
}

.ui-keyboard-case {
  width: 100%;
  background-color: white;
  color: black;
  padding: 5px 15px;
  font-family: FoundryWilsonNormal;
  font-size: 24px;
  border-radius: 0.25rem;
}

.keyboard-wrapper {
  width: 100%;
}
</style>

<script>
export default {
  name: "App",

  data() {
    return {
      showCancel: true,
      dialog: true
    };
  },

  watch: {
    $route() {
      this.updateCancelButton();
      if (this.$route.name == "record") {
        document.querySelector("body").style.color = "#544b45";
        document.querySelector("body").style.backgroundColor = "#e4e1db";
      } else {
        document.querySelector("body").style.color = "#ffffff";
        document.querySelector("body").style.backgroundColor = "#00692f";
      }
    }
  },

  methods: {
    open() {
      console.log(this.$route.params['lang']);
      this.$modal.show("cancel-modal");
    },
    close() {
      this.$modal.hide("cancel-modal");
    },
    cancelModalOpened() {
      if (global.wpfBridge) {
        global.wpfBridge.modalShow();
      }
    },
    cancelModalClosed() {
      if (global.wpfBridge) {
        global.wpfBridge.modalHide();
      }
    },
    restart() {
      this.$router.push("/");
      this.$modal.hide("cancel-modal");
    },
    updateCancelButton() {
      this.showCancel =
        this.$route.name != "home" && this.$route.name != "welcome";
    },

    getDialogText() {
      return this.$route.params['lang'] == 'en'
        ? 'Du you really want to quit?'
        : 'Wollen Sie wirklich beenden?';
    },
    getOkText() {
      return this.$route.params['lang'] == 'en'
        ? 'Yes, quit'
        : 'Ja, beenden';
    },
    getCancelText() {
      return this.$route.params['lang'] == 'en'
        ? 'No, continue'
        : 'Nein, weitermachen';
    }
  },

  mounted() {}
};
</script>
